import * as types from './actionTypes';
import teslaVehiclesApi from '../api/teslaVehiclesApi';

export function loadTeslaVehiclesSuccess(teslaVehicles) {
  return {type: types.LOAD_TESLA_VEHICLES_SUCCESS, teslaVehicles};
}

export function loadTeslaVehicles(deviceId, authToken) {  
  return function(dispatch) {
    return teslaVehiclesApi.getTeslaVehicles(deviceId, authToken).then(teslaVehicles => {
      dispatch(loadTeslaVehiclesSuccess(teslaVehicles));
    }).catch(error => {
      throw(error);
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/teslaVehicleActions.js